import { AppUtil } from 'kuaidong-lib'
import { ExamDrill } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/exam/List.vue')
const Entry = () => import('../views/exam/Entry.vue')
const Details = () => import('../views/exam/Details.vue')
const Progress = () => import('../views/exam/Progress.vue')

const EditDrill = () => import('../views/exam/EditDrill.vue')
const EditGeneral = () => import('../views/exam/EditGeneral.vue')

const Stats = () => import('../views/exam/Stats.vue')
const StatsClazz = () => import('../views/exam/StatsClazz.vue')
const StatsStudent = () => import('../views/exam/StatsStudent.vue')

const listRoute: RouteConfig = {
  path: '/exam-list',
  name: 'exam_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试列表',
  },
}

const entryRoute: RouteConfig = {
  path: '/exam-entry',
  name: 'exam_entry',
  component: Entry,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试详情',
  },
}

const detailsRoute: RouteConfig = {
  path: '/exam-details',
  name: 'exam_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试信息',
  },
}

const progressRoute: RouteConfig = {
  path: '/exam-progress',
  name: 'exam_progress',
  component: Progress,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试进度',
  },
}

const editDrillRoute: RouteConfig = {
  path: '/exam-edit-drill',
  name: 'exam_edit_drill',
  component: EditDrill,
  props: (route) => ({
    ...route.query,
    ...route.params,
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
  meta: {
    title: '编辑测试',
    stepTitle: '选择测试项目',
    nextButtonText: '确认',
  },
}

const editGeneralRoute: RouteConfig = {
  path: '/exam-edit-general',
  name: 'exam_edit_general',
  component: EditGeneral,
  props: (route) => ({
    ...route.query,
    ...route.params,
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
  meta: {
    title: '编辑测试',
    stepTitle: '填写测试信息',
    nextStep: editDrillRoute.name,
  },
}

const statsRoute: RouteConfig = {
  path: '/exam-stats',
  name: 'exam_stats',
  component: Stats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试报告',
  },
}

const statsClazzRoute: RouteConfig = {
  path: '/exam-stats-clazz',
  name: 'exam_stats_clazz',
  component: StatsClazz,
  props: (route) => ({ ...route.query, ...route.params, clazzId: +route.query.clazzId }),
  meta: {
    title: '测试班级详情',
  },
}

const statsStudentRoute: RouteConfig = {
  path: '/exam-student-detail',
  name: 'exam_student_detail',
  component: StatsStudent,
  props: (route) => ({ ...route.query, ...route.params, uuid: route.query.uuid }),
  meta: {
    title: '个人完成情况',
  },
}

export default [
  listRoute,
  entryRoute,
  detailsRoute,
  progressRoute,

  editDrillRoute,
  editGeneralRoute,

  statsRoute,
  statsClazzRoute,
  statsStudentRoute,
]

export function navigateToExamList(router: VueRouter, activityId?: string) {
  router.push({ name: listRoute.name, query: { activityId } })
}

export function navigateToExamEntry(router: VueRouter, id: string) {
  router.push({ name: entryRoute.name, query: { id } })
}

export function redirectToExamEntry(router: VueRouter, id: string) {
  router.replace({ name: entryRoute.name, query: { id } })
}

export function navigateToExamDetails(router: VueRouter, id: string) {
  router.push({ name: detailsRoute.name, query: { id } })
}

export function navigateToExamProgress(router: VueRouter, id: string) {
  router.push({ name: progressRoute.name, query: { id } })
}

export function navigateToExamEditDrill(router: VueRouter) {
  router.push({ name: editDrillRoute.name, query: { currentStep: '2', totalSteps: '2' } })
}

export function navigateToExamEditGeneral(router: VueRouter) {
  router.push({ name: editGeneralRoute.name, query: { currentStep: '1', totalSteps: '2' } })
}

export function redirectToExamEditGeneral(router: VueRouter) {
  router.replace({ name: editGeneralRoute.name, query: { currentStep: '1', totalSteps: '2' } })
}

export function navigateToExamStats(router: VueRouter, id: string) {
  router.push({ name: statsRoute.name, query: { id } })
}

export function navigateToExamStatsClazz(router: VueRouter, id: string, clazzId: string) {
  router.push({ name: statsClazzRoute.name, query: { id, clazzId: String(clazzId) } })
}

export function navigateToExamStatsStudent(router: VueRouter, id: string, clazzId: number, userId: string) {
  router.push({
    name: statsStudentRoute.name,
    query: { body_exam_uuid: id, class_id: String(clazzId), user_id: userId },
  })
}

export function navigateToExamDrillStandardScore(router: VueRouter, drill: ExamDrill) {
  AppUtil.jumpUrlNewTab(
    `${process.env.VUE_APP_REPORT_HOST}/about/standard-score/Index/?grade=${drill.grade_no}&gender=${
      drill.gender_scope === 'F' ? 'F' : 'M'
    }&drill=${drill.item_value}`,
    '体测项目评分标准'
  )
}

export function navigateToExamDrillStandardScoreRate() {
  AppUtil.jumpUrlNewTab(`${process.env.VUE_APP_REPORT_HOST}/about/standard-score/Rate`, '体测总体评分标准')
}
